import { useSetUrlSearchParam, useUrlQueryParam } from "@/pages/aigc/hooks/useQuery";

// 公共状态管理,抽离出来
export const useModalOpen = () => {
  const [{ modalDetail }, setModalDetail] = useUrlQueryParam(['modalDetail']);
  const [{ modalDel }, setModalDel] = useUrlQueryParam(['modalDel']);
  const [{ modalRelevant }, setModalRelevant] = useUrlQueryParam(['modalRelevant']);
  // TODO:处理失效的问题,估计是路由模式匹配不到,
  const setUrlParams = useSetUrlSearchParam();

  const detailopen = () => setModalDetail({ modalDetail: true });
  const delopen = () => setModalDel({ modalDel: true });
  const relevantopen = () => setModalRelevant({ modalRelevant: true });

  const detailClone = () => setModalDetail({ modalDetail: '' });
  const delclone = () => setModalDel({ modalDel: '' });
  const relevantclone = () => setModalRelevant({ modalRelevant: '' });

  return {
    modalDetailStat: modalDetail === true,
    modalDelStat: modalDel === true,
    modalRelevantStat: modalRelevant === true,
    delclone,
    detailClone,
    detailopen,
    delopen,
    relevantopen,
    relevantclone
  };
};

